<template>
  <v-content>
    <v-dialog v-model="confirmdialog" persistent>
      <v-card class="ticket_dialogue text-center">
        <v-card-title class="body-2 maincolor-bg justify-center">
          こちらの画面をスタッフに提示して下さい
        </v-card-title>
        <div class="text-center pa-5" style="padding-left: 12px !important;padding-right: 12px !important">
          <div class="text-center" style="display: flex; justify-content: center;">
            <barcode v-if="this.barcode_type == 4" v-model="barcode" :options="{ format: this.barcode_format,displayValue: true, width:1 }"></barcode>
            <barcode v-else v-model="barcode" :options="{ format: this.barcode_format,displayValue: true }"></barcode>
          </div>
          <br><br>
          <v-btn rounded class="maincolor-bg default_button" :disabled="btnDisabled" @click.stop="use()">使用する</v-btn>
          <br><br>
          <v-btn rounded class="caption font-weight-black maincolor-btn2" @click="confirmdialog = false">キャンセルする</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script>
export default {
  props: ['item', 'init'],

    data: () => ({
        confirmdialog: false,
        ticket_id: null,
        barcode_type: null,
        barcode: null,
        btnDisabled:false
    }),
    computed: {
      barcode_format(){
        let barcodeType = ""
        switch (this.barcode_type){
          case 1:
            barcodeType = 'EAN13'
            break;
          case 2:
            barcodeType = 'CODE128'
            break;
          case 4:
            barcodeType = 'CODE39'
            break;
        }
        return barcodeType
        // CODE128 :CODE128
        // EAN / UPC :EAN13 UPC EAN8 EAN5 EAN2
        // CODE39 :CODE39
        // ITF-14 :ITF14
        // MSI :MSI MSI10 MSI11 MSI1010 MSI1110
        // Pharmacode :pharmacode
        // Codabar :codabar
      },
    },
    methods: {
      use() {
        if (this.btnDisabled) return
        
        this.btnDisabled = true
        this.confirmdialog = false
        this.$emit('use')
      },
      open(item) {
        this.ticket_id = item.id
        this.barcode_type = item.barcode_type
        this.barcode = item.barcode
        this.confirmdialog = true
      },
      close() {
        this.confirmdialog = false
      },
      submit() {
      },
      clear() {
      },
      UseTicket(id) {
        this.ticket_id = id
      },
      setBtnDisabled(flg) {
        //「使用する」ボタンのdisabledへ設定
        this.btnDisabled = flg
      }
  },
}
</script>
